import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOverview () {
    return Api()
      .get('/v1/orders')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Order.Messages.GetOrdersErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async create (order) {
    order.uid = '00000000-0000-0000-0000-000000000000'
    return Api()
      .post('/v1/orders', order)
      .then(function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Order.Messages.CreateOrderErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
